import { cityURL } from '@root/components/locations/routes';

type RegionPage = {
  slug: string;
  title: string;
};

const slugify = (value: string) =>
  value
    .toLowerCase()
    .replace(/['.]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

/**
 * City names on the homepage link to region-level `/locations/:slug` pages when
 * a matching Location__Page exists; otherwise fall back to the city storage URL.
 */
export const resolveCityRegionPageUrl = ({
  cityName,
  citySlug,
  stateSlug,
  pages,
}: {
  cityName: string;
  citySlug: string;
  stateSlug: string;
  pages: ReadonlyArray<RegionPage>;
}): string => {
  const candidates = new Set([
    citySlug,
    slugify(cityName),
    slugify(cityName.split(',')[0] ?? cityName),
  ]);

  const page = pages.find((entry) => candidates.has(entry.slug));
  if (page) {
    return `/locations/${page.slug}`;
  }

  return cityURL(stateSlug, citySlug, 'storage');
};
